// extracted by mini-css-extract-plugin
export default {"component":"CFFGEz","text":"wbp_j0","link":"R2Rzsa","info":"pp0tez"};